
namespace RioERP.Invoices {
    export class OrderSourcesColumns {
        static columnsKey = 'Invoices.OrderSources';
    }
}